<template>
  <div
    @click="handleClick"
    v-if="stype === 'small'"
    class="feature-post d-block cursor-pointer"
  >
    <!-- 使用 div 替代 img 标签，并设置背景图片 -->
    <div
      class="feature-post-thumb"
      :style="{
        backgroundImage: `url(${datas.coverurl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }"
    ></div>
    <div class="feature-post-content">
      <div class="post-meta">
      </div>
      <h4 class="title">
        {{ datas.title }}
      </h4>
    </div>
  </div>

  <div
    @click="handleClick"
    v-else-if="stype === 'big'"
    class="single-play-post-item d-block cursor-pointer"
  >
    <div
      class="single-play-post-bg"
      :style="{
        backgroundImage: `url(${datas.coverurl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '493px',
        height: '383px'
      }"
    ></div>

    <div class="single-play-post-content">
      <div class="post-meta">
        <div class="meta-date">
        </div>
      </div>
      <h3 class="title">
        {{ datas.title }}
      </h3>
    </div>
  </div>
</template>

<script>
import { clickPlacement } from '@/api/placement.js';
export default {
  props: {
    datas: {
      type: Object,
    },
    stype: {
      type: String,
    },
  },
  methods: {
    handleClick() {
      if (this.datas && this.datas.link && this.datas.id) {
        const url = clickPlacement(this.datas.id, this.datas);
        window.open(url, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.single-play-post-item {
  position: relative;
}

.single-play-post-bg {
  position: relative;
}

.play-btn,
.trending-btn {
  position: absolute;
  z-index: 1;
}

.play-btn {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.trending-btn {
  top: 10px;
  left: 10px;
}

.feature-post-thumb {
  /* 默认宽度和高度，适用于大屏幕 */
  width: 262px;
  height: 198px;
}

/* 中等屏幕，例如平板电脑 */
@media (max-width: 992px) {
  .feature-post-thumb {
    /* width: 30vw; */
    width: 100%;
    height: 22.5vw; /* 保持与默认尺寸相同的宽高比 */
  }
}

/* 小屏幕，例如手机 */
@media (max-width: 768px) {
  .feature-post-thumb {
    width: 100%;
    height: 75vw; /* 保持与默认尺寸相同的宽高比 */
  }
}

/* 超小屏幕 */
@media (max-width: 576px) {
  .feature-post-thumb {
    width: 100%;
    height: 75vw; /* 保持与默认尺寸相同的宽高比 */
  }
}

/* iPad Pro 1024 宽度 */
@media (max-width: 1024px) {
  .feature-post-thumb {
    width: 100%; /* 确保图片占满容器宽度 */
    height: auto; /* 自动计算高度以保持图片比例 */
    aspect-ratio: 262 / 198; /* 保持默认宽高比，262 和 198 是之前默认的宽高值 */
  }
}
.title{
  font-size: 14px;
  color: #ffffff;
}
</style>
